import { useGetETSTicketNotificationsQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import { useETSTicketsQueryParams } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { Badge } from 'gcs-common/design-system/ui/badge';
import { TICKET_DASHBOARD_TABS, TicketDashboardTabNames } from 'gcs-common/slices/tickets/ticketsConstants';
import type { Entries } from 'type-fest';
import styles from './styles.module.scss';

const StatusFilter = () => {
  const { etsTicketsfilters: filters, setETSTicketsQueryParams } = useETSTicketsQueryParams();

  const { data } = useGetETSTicketNotificationsQuery();

  const notListedUnreadCount =
    data?.notifications?.reduce((count, notification) => {
      if (notification.ticketStatus === 'done' && notification.ticketAdditionalStatus === 'not_listed') {
        return count + 1;
      }
      return count;
    }, 0) ?? 0;

  const activeTab = filters.tab || '';

  const setTab = (tab?: TicketDashboardTabNames) => {
    setETSTicketsQueryParams({
      creatorIds: tab === TicketDashboardTabNames.NOT_LISTED ? 'None' : filters.creatorIds,
      tab,
    });
  };

  return (
    <div className={styles.statusFilterContainer}>
      <button
        className={`${styles.statusTab} ${activeTab === '' ? styles.activeTab : ''}`}
        onClick={() => setTab(undefined)}
        type="button"
      >
        Alle
      </button>
      {(Object.entries(TICKET_DASHBOARD_TABS) as Entries<typeof TICKET_DASHBOARD_TABS>).map(([key]) => {
        const entry = TICKET_DASHBOARD_TABS[key];
        if (!entry) return null;
        const { title } = entry;
        return (
          <button
            key={key}
            className={`${styles.statusTab} ${activeTab === key ? styles.activeTab : ''}`}
            onClick={() => setTab(key)}
            type="button"
          >
            <div className="flex items-center gap-2">
              <div>{title}</div>
              {title === TICKET_DASHBOARD_TABS.not_listed.title && notListedUnreadCount > 0 && (
                <Badge variant="solid_error">{notListedUnreadCount}</Badge>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default StatusFilter;
